import { useCurrentUser, useUsers } from "@crm/api";
import { Users, Building2, AlertCircle, CheckCircle } from "lucide-react";

export function DashboardPage() {
  const { data: user } = useCurrentUser();
  const { data: usersData } = useUsers();

  return (
    <div className="p-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-semibold text-foreground">Dashboard</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Welcome back, {user?.first_name}
        </p>
      </div>

      {/* Stats Grid */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatCard
          title="Total Users"
          value={usersData?.count ?? 0}
          icon={Users}
        />
        <StatCard title="Active Clients" value={0} icon={Building2} />
        <StatCard title="Open Incidents" value={0} icon={AlertCircle} />
        <StatCard title="Resolved Today" value={0} icon={CheckCircle} />
      </div>

      {/* Placeholder content */}
      <div className="mt-8 rounded-lg border border-border bg-card p-8 text-center">
        <p className="text-muted-foreground">
          Dashboard widgets and analytics will be added here.
        </p>
      </div>
    </div>
  );
}

interface StatCardProps {
  title: string;
  value: number;
  icon: React.ComponentType<{ className?: string }>;
}

function StatCard({ title, value, icon: Icon }: StatCardProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-muted-foreground">{title}</p>
          <p className="mt-1 text-3xl font-semibold text-foreground">{value}</p>
        </div>
        <div className="rounded-md bg-muted p-3">
          <Icon className="h-5 w-5 text-muted-foreground" />
        </div>
      </div>
    </div>
  );
}
